import modelBase from '../../models/model-base.model';
import modelBaseV2 from '../model-base-v2.model';

const codeMasterModel = {
  getByCategory: function (successCallBack, failureCallBack, param) {
    const params = {
      category: param.category,
    };

    if (param.countryCode?.length > 0) {
      params.countryCode = param.countryCode;
    }

    var path = '/api/codemaster/:category';
    modelBase.get(successCallBack, failureCallBack, path, { params });
  },

  search: function (successCallBack, failureCallBack, param) {
    var path = `/api/codemaster/search/${param.category}?value=${param.value}&countryCode=${param.countryCode}`;
    modelBase.get(successCallBack, failureCallBack, path);
  },

  // ---- New methods with modelBaseV2 below ----

  getByCategoryV2: function (params) {
    let options = {};
    options.params = params;

    return modelBaseV2.get(`/api/codemaster/:category`, options);
  },

  searchByCategoryV2: (category, params) => {
    const qs = modelBaseV2.toQueryString(params)
    return modelBaseV2.get(`/api/codemaster/search/:category?${qs}`, { params: { category } })
  },

  getCodemasterList: (countryCode) => {
    const params = {
      countryCode
    };

    return modelBaseV2.get('/api/codemaster/admin/:countryCode', { params });
  },

  getCodemasterCategoryData: (countryCode, category) => {
    const params = {
      countryCode,
      category
    };

    return modelBaseV2.get('/api/codemaster/admin/:countryCode/:category', { params });
  },

  getCodemasterDetail: (countryCode, category, code) => {
    const params = {
      countryCode,
      category,
      code
    };

    return modelBaseV2.get('/api/codemaster/admin/:countryCode/:category/:code', { params });
  },

  addCodemasterDetail: (countryCode, category, body) => {
    const params = {
      countryCode,
      category
    };

    return modelBaseV2.post('/api/codemaster/admin/:countryCode/:category', { params, body });
  },

  updateCodemasterDetail: (countryCode, category, code, body) => {
    const params = {
      countryCode,
      category,
      code
    };

    return modelBaseV2.post('/api/codemaster/admin/:countryCode/:category/:code', { params, body });
  },

  deleteCodemasterDetail: (countryCode, category, code) => {
    const params = {
      countryCode,
      category,
      code
    };

    return modelBaseV2.post('/api/codemaster/admin/delete/:countryCode/:category/:code', { params });
  },

  getCommonCodeNameForPopup: (params) => {
    return modelBaseV2.get('/api/posmMaster/getCommonCodeNameForPopup', { params })
  }
}

export default codeMasterModel
